@use '@lib/assets/styles/main.scss' as *;

.menuRoot {
  margin: 0 -32px;
}
